import React from 'react'

import styles from './styles.module.scss'

import ProfileNavItem from './ProfileNavItem'
import { profilePaths } from '../../constants/constans'
import useNavigationProfile from './useNavigationProfile'

const ProfileNav = ({ onCloseMobileMenu }) => {
  const { navigation } = useNavigationProfile()

  return (
    <nav className={styles.nav}>
      {Object.keys(navigation).map((path) => {
        const { ...rest } = navigation[path]

        if (path === profilePaths.general) {
          return (
            <div
              key={path}
              style={{
                position: 'relative',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
              id='tour-step-1'
              className={styles.step}
            >
              <ProfileNavItem onCloseMobileMenu={onCloseMobileMenu} link={path} {...rest} />
            </div>
          )
        }

        return <ProfileNavItem onCloseMobileMenu={onCloseMobileMenu} key={path} link={path} {...rest} />
      })}
    </nav>
  )
}

export default ProfileNav
